import {useState} from "react";

import {AntdTable} from "@/components/custom/AntdTable/AntdTable.jsx";
import {WhereUsed} from "@/variants/index.js";

export const WhereUsedTable = ({equipment}) => {
	const [tableParams, setTableParams] = useState({
		pagination: {
			current: 1,
			pageSize: 50,
		},
	});

	function handleTableChange(pagination, filters, sorter) {
		setTableParams({
			pagination,
			filters,
			...sorter,
		});
	}

	return (
		<AntdTable
			tableSize={"small"}
			scroll={300}
			data={WhereUsed.getRows(equipment)}
			pagination={tableParams.pagination}
			onChange={handleTableChange}
			columns={WhereUsed.getColumns(equipment)}
			data-testid="where-used-table"
		/>
	);
};
